import React, { useEffect, useState } from 'react';
import Papa from 'papaparse';
import {
    Table, TableHead, TableBody, TableRow, TableCell, TableSortLabel, Paper, TableContainer
} from '@mui/material';
import './PlayerStatistics.css';

function PlayerStatistics() {
    const [data, setData] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    useEffect(() => {
        fetch('/data/player_statistics.csv')
            .then(response => response.text())
            .then(csvText => {
                Papa.parse(csvText, {
                    header: true,
                    complete: (result) => {
                        setData(result.data);
                    }
                });
            });
    }, []);

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const sortedData = [...data].sort((a, b) => {
        const aValue = isNaN(a[sortConfig.key]) ? a[sortConfig.key] : parseFloat(a[sortConfig.key]);
        const bValue = isNaN(b[sortConfig.key]) ? b[sortConfig.key] : parseFloat(b[sortConfig.key]);

        if (aValue < bValue) {
            return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
            return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
    });

    const getHighestValues = () => {
        const highestValues = {};

        data.forEach(row => {
            Object.keys(row).forEach(key => {
                const value = parseFloat(row[key]);
                if (!isNaN(value)) {
                    if (!highestValues[key] || value > highestValues[key]) {
                        highestValues[key] = value;
                    }
                }
            });
        });

        return highestValues;
    };

    const highestValues = getHighestValues();

    return (
        <div className="player-statistics">
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            {data.length > 0 && Object.keys(data[0]).map((key, index) => (
                                <TableCell key={index} sortDirection={sortConfig.key === key ? sortConfig.direction : false}>
                                    <TableSortLabel
                                        active={sortConfig.key === key}
                                        direction={sortConfig.direction}
                                        onClick={() => handleSort(key)}
                                    >
                                        {key}
                                    </TableSortLabel>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sortedData.map((row, rowIndex) => (
                            <TableRow key={rowIndex}>
                                {Object.entries(row).map(([key, value], colIndex) => (
                                    <TableCell key={colIndex} className={parseFloat(value) === highestValues[key] ? 'highest-value' : ''}>
                                        {value}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}

export default PlayerStatistics;